import { render, staticRenderFns } from "./couponList_dy.vue?vue&type=template&id=5d12f9c8&scoped=true"
import script from "./couponList_dy.vue?vue&type=script&lang=ts"
export * from "./couponList_dy.vue?vue&type=script&lang=ts"
import style0 from "./couponList_dy.vue?vue&type=style&index=0&id=5d12f9c8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d12f9c8",
  null
  
)

export default component.exports